import React, { forwardRef } from 'react';
import classNames from 'classnames';
import Style from './FJAutoLoading.module.less';
import FJLoading from './FJLoading';

const FJAutoLoading = forwardRef((props, ref) => {
    const { shown, type, innerStyle, style, strokeColor, className } = props;
    return (
        <div className={classNames(Style.container, shown && Style.active, className)} ref={ref} style={style}>
            <FJLoading style={innerStyle} type={type} strokeColor={strokeColor} />
        </div>
    );
});

export default FJAutoLoading;
